function CategoriesCtrl($scope, $timeout, $state, $controller, GeneralUtilsService, IconsService, RulesService, FieldsService) {

	$controller('ConfigController', {$scope: $scope, $timeout: $timeout});

	const FieldTypes = FieldsService.getFieldTypes();

	$scope.fields = {
		name: 'items',
		id: 'items',
		types: [
			{
				name: 'Applications',
				field: FieldTypes.allApps,
			},
			{
				name: 'Custom Applications',
				field: FieldTypes.customApplications,
			},
			{
				name: 'Categories',
				field: FieldTypes.categories,
			},
			{
				name: 'Fully Qualified Domain',
				field: FieldTypes.FQDN,
			},
			{
				name: 'Top Level Domain Name',
				field: FieldTypes.TLD,
			},
			{
				name: 'Custom Service (By IP)',
				field: FieldTypes.customService,
			},
			{
				name: 'Services',
				field: FieldTypes.services
			},
		]
	};

	$scope.ContentTypeDisplay = {
		urlf: 'URL Category',
		apps: 'Application Category',
		apps_urlf: 'Applications and URL Category',
	};

	$scope.tableConfig = {
		hasChanges: $scope.$root.hasChanges,
		noAutoCheckboxSelect: true,
		mode: 'list',
		accountId : $state.params.accountId,
		dataURL : function() {
			return "/getCategories?accountId=" + ($state.params.accountId? $state.params.accountId : "");
		},
		titleSearch: 'Categories',
		height: $scope.getContentHeight(),
		pageSize: 50,
		afterUpdate: function(){
			if(!$scope.loaded){
				return;
			}
			if($scope.$root){
				$scope.$root.updateScroll('.pane.left .nano');
			}
		},
		searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
		sortButton: true,
		fields : [
			{"label":"Name","path":"name"},
			{"label":"Origin","path":"importType"},
			{"label":"Creation Date","path":"creationDate"},
		],
		unselectable: function(category) {
                    return category.appId;
        },
		type : "CustomCategory",
		addAction : function(type) {
			$scope.newCategory = {id:GeneralUtilsService.getRandomId(),"name":""};
			$scope.$root.openPopup('addCategoryDlg');
		},
		actions: ["remove"],
		onSelect: function(index) {
			$scope.selectedCategoryIndex = index;
			$scope.showCategory($scope.tableConfig.items[index]);
		},
		importNames:{'CUSTOM':'Custom','APP':'System'},
		sortList: [{'sortField':'importType','dir':'ASC'},{'sortField':'name','dir':'ASC'}]
	};

	$scope.addCategory = function() {
		var params = {'accountId': $state.params.accountId,'type':'CustomCategory','save':true};
		$scope.loadingSaveNew = true;
		store.save({
			path: '/add',
			data: $scope.newCategory,
			dataObj: 'json',
			queryParams: params,
			success: function(data) {
				$scope.loadingSaveNew = false;
				$scope.$root.handleServerResponse(data, 'newCategory', 'Custom Category added successfully');
				if(data.status !== 'ERROR'){
					$scope.tableConfig.selectedId = data.model.id;
					$scope.datamodified = new Date().getTime();
					$scope.$root.closePopup('addCategoryDlg');
				}
			}
		});
	};


	$scope.showCategory = function (category) {
		var idArg = category.importType === 'APP' ? {appid:category.appId} : {customcategoryId: category.id};
		store.fetch({
			queryParams: idArg,
			path: 'getCategory',
			success: function(data) {
				$scope.category = data;
				$scope.orig = angular.copy(data);
				$scope.showWhatItems = 'categories';
				$scope.$digest();
			}
		});

	};

	$scope.saveChanges = function () {
		$scope.loading = true;
		var params = {'customcategoryId':$scope.category.id,'save':true, newSaveMethod: true, 'accountId': $state.params.accountId};

		$scope.category.newSaveMethod = true;

		store.save({
			path: '/edit',
			data: $scope.category,
			dataObj: 'json',
			queryParams: params,
			success: function(data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, 'customCategory', 'Custom Category saved successfully');
				if(data.status !== 'ERROR'){
					$scope.showCategory(data.model, true);
				}
			}
		});
	};

	$scope.$root.hasChanges = function(){
		var category = $scope.category;
		if(!category) return false;
		if(category.id < 0) return true; //new category
		if(!angular.equals($scope.category,$scope.orig)) return true;
		return false;
	};


	$scope.icons = IconsService.getIcons();

	function initiateCurrentItems(item) {
		if (!item.items) {
			item.items = [];
		}
		if (!item.fqdn) {
			item.fqdns = [];
		}
		$scope.items = item.items;
	}

	$scope.addServiceConfig = RulesService.getServicesConfig($state.params.accountId, null, true);

	$scope.itemsEntryListSelect = function (id, item) {
		initiateCurrentItems(item);
		$scope.appsDataModified = new Date().getTime();
		$scope.servicesDataModified = new Date().getTime();
		initiateAddServiceConfigProperties();

		/*
		 * this section is responsible for filling the
		 * addServiceConfig properties after we initiated them in
		 * initiateAddServiceConfigProperties
		 */
		item.items.forEach(function(service){
			if(!service.ip){
				if (service.type === 'Service') {
					// Service
					$scope.addServiceConfig.servicesConfig.selectedItems.push(service);
				} else if(service.type === 'AppCategory'){
					// Category
					$scope.addServiceConfig.categoriesConfig.selectedItems.push(service);
				} else if (service.type === 'CustomApp') {
					$scope.addServiceConfig.customAppsConfig.selectedItems.push(service);
				} else if (service.type != 'FQDN' && service.type != 'TLD') {
					// APP
					service.type = 'App'; // Fill type on existing configuration
					$scope.addServiceConfig.appsConfig.selectedItems.push(service);

				}
			}
		});
		$scope.addServiceConfig.freeText = item.items.filter(function (dest) {return dest.type === "TLD"}).map(function (dest) {return dest.id}).join();
		$scope.addServiceConfig.fqdnFreeText = item.items.filter(function (dest) {return dest.type === "FQDN"}).map(function (dest) {return dest.id}).join();
		// only the custom generated
		$scope.addServiceConfig.newIPApplication.ips = item.items.filter(function(serv) {return serv.ip && !serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();
		// only the auto generated for ipsec services
		$scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = item.items.filter(function(serv) {return serv.ip && serv.autoGenerated;}).map(function (service) {return service.display_name;}).join();

		$scope.currentItem = item;
		$scope.$root.openPopup('categoriesServicesDlg');
	};

	function initiateAddServiceConfigProperties() {
		// when opening the dialog - check all existing items
		$scope.addServiceConfig.categoriesConfig.selectedItems = [];
		$scope.addServiceConfig.appsConfig.selectedItems = [];
		$scope.addServiceConfig.servicesConfig.selectedItems = [];
		$scope.addServiceConfig.newIPApplication.ips = "";
		$scope.addServiceConfig.newIPApplication.autoGeneratedIPSec = "";
		$scope.addServiceConfig.freeText = "";
		$scope.addServiceConfig.fqdnFreeText = "";
		$scope.addServiceConfig.allowAnyItems = false;
		$scope.addServiceConfig.customAppsConfig.selectedItems = [];
	}

	$scope.addItems = function() {
		var ok = true;

		var currentWhat = $scope.category.items;
		currentWhat.length = 0;

		fillAppConfig(currentWhat);
		fillServicesConfig(currentWhat);
		fillCategoryConfig(currentWhat);


		// IPs
		if ($scope.addServiceConfig.newIPApplication.ips) {
			var ips = $scope.addServiceConfig.newIPApplication.ips.split(",");
			ips.forEach(function (ipStr) {
				if (!ipStr || ipStr === '') return;
				if (ipStr.indexOf(":") < 0) {
					ok = false;
					alert("Incorrect format for custom service, please enter <name>:<ip address> (sampleservice:10.10.10.1,newservice:20.20.20.8)");
				}
				if (ok) {
					var ipSplitted = ipStr.split(":");
					currentWhat.push({
						"id": ipSplitted[1],
						"display_name": ipSplitted[0] + ":" + ipSplitted[1],
						"ip": ipSplitted[1],
						"autoGenerated": false,
						desc: ipSplitted[0],
					});
				}
			});
		}
		if ($scope.addServiceConfig.newIPApplication.autoGeneratedIPSec) {
			var autoGeneratedIPSec = $scope.addServiceConfig.newIPApplication.autoGeneratedIPSec.split(",");
			autoGeneratedIPSec.forEach(function (ipStr) {
				var ipSplitted = ipStr.split(":");
				currentWhat.push({
					"id": ipSplitted[1],
					"display_name": ipSplitted[0] + ":" + ipSplitted[1],
					"ip": ipSplitted[1],
					"autoGenerated": true
				});
			});
		}
		if (ok) {
			$scope.$root.closePopup('categoriesServicesDlg');
		}
	};

	/**
	 * method for filling the app config
	 * @param currentWhat
	 */
	function fillCategoryConfig(currentWhat) {
		// Apps
		$scope.addServiceConfig.categoriesConfig.selectedItems.forEach(function (category) {
			if (currentWhat.indexOf(category) < 0) {
				category.type = "AppCategory";
				currentWhat.push(category);
			}
		});
	}


	/**
	 * method for filling the app config
	 * @param currentWhat
	 */
	function fillAppConfig(currentWhat) {
		// Apps
		$scope.addServiceConfig.appsConfig.selectedItems.forEach(function (service) {
			if (currentWhat.indexOf(service) < 0) {
				service.type = "App";
				currentWhat.push(service);
			}
		});
	}


	/**
	 * method for filling the services config
	 * @param currentWhat
	 */
	function fillServicesConfig(currentWhat) {
		// services
		$scope.addServiceConfig.servicesConfig.selectedItems.forEach(function (service) {
			if (currentWhat.indexOf(service) < 0) {
				service.type = "Service";
				currentWhat.push(service);
			}
		});


		$scope.addServiceConfig.customAppsConfig.selectedItems.forEach(function (app) {
			if (currentWhat.indexOf(app) < 0) {
				app.type = 'CustomApp';
				app.id = app.id;
				if (app.definitions) {
					delete app.definitions;
				}
				currentWhat.push(app);
			}
		});

		if ($scope.addServiceConfig.freeText) {
			$scope.addServiceConfig.freeText.split(",").forEach(function (tld) {
				if (tld.trim().length > 0)
					if (!_.find(currentWhat, {'id': tld.trim()}))
						currentWhat.push({"id": tld.trim(), "name": tld.trim(), "type": "TLD"});
			});
		}
		if ($scope.addServiceConfig.fqdnFreeText) {
			$scope.addServiceConfig.fqdnFreeText.split(",").forEach(function (fqdn) {
				if (fqdn.trim().length > 0)
					if (!_.find(currentWhat, {'id': fqdn.trim()}))
						currentWhat.push({"id": fqdn.trim(), "name": fqdn.trim(), "type": "FQDN"});
			});
		}
	}

	$scope.customAppsConfig = {
		titleSearch: true,
		dataURL : function () {
			return "/getCustomApps?accountId=" + $state.params.accountId;
		},
		actions: [],
		pageSize:5,
		sortField:"name",
		searchField:"name",
		fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Category","path":"categoryId","template":"<span>{{item.categoryId | capitalize}}</span>"}],
		type : "CustomApp",
		parseData: function (data) {
			var items = [];
			for (var key in data) {
				var item = data[key];
				item.id = item.appId;
				item.type = 'CustomApp';

				item.display_name = item.name;
				items.push(item);
			}
			return items;
		},
		selectedItems:[]
	};
}
